export function getArrayObjectsColumn (arr: Array<{[index: string]: any}>, column: string): any[] {
    const result: any[] = []
    arr.map(el => { if (el.hasOwnProperty(column)) result.push(el[column]) })
    return result
}
